import Vue from 'vue';

import './helpers/filters';

import Competitions from './components/competitions/Competitions.vue';
import Competition from './components/competitions/Competition.vue';
import Match from './components/competitions/Match.vue';
import Pool from './components/competitions/Pool.vue';
import Events from './components/events/Events.vue';
import Event from './components/events/Event.vue';
import Intake from './components/intakes/Intake.vue';

window.addEventListener('load', () => {
    new Vue({
        el: '#app',

        components: {
            Competitions,
            Competition,
            Match,
            Pool,
            Events,
            Event,
            Intake
        },
    });
});
